module.exports = __webpack_public_path__ + "assets/img/daily_task_title.58bb1894.png";